class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.container = document.querySelector('#product-grid');
    this.loadingIndicator = this.querySelector('.infinite-scroll-loading');
    this.isLoading = false;
    if (this.container) {
      this.initObserver();
    }
  }

  initObserver() {
    const options = {
      rootMargin: '400px',
      threshold: 0
    };
    
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);
    this.observer.observe(this);
  }

  async handleIntersect(entries) {
    if (entries[0].isIntersecting && !this.isLoading) {
      this.loadMoreProducts();
    }
  }

  async loadMoreProducts() {
    const nextUrl = this.getAttribute('data-next-url');
    if (!nextUrl) return;

    this.isLoading = true;
    if (this.loadingIndicator) this.loadingIndicator.style.display = 'block';

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Network response was not ok');
      const text = await response.text();
      
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      
      const newContainer = htmlDocument.querySelector('#product-grid');
      if (newContainer && this.container) {
        const newItems = newContainer.querySelectorAll('.grid__item');
        newItems.forEach(item => {
          this.container.appendChild(item);
        });
      }

      const newTrigger = htmlDocument.querySelector('infinite-scroll');
      if (newTrigger && newTrigger.getAttribute('data-next-url')) {
        this.setAttribute('data-next-url', newTrigger.getAttribute('data-next-url'));
      } else {
        this.observer.disconnect();
        this.remove();
      }
    } catch (err) {
      console.error('Failed to load more products:', err);
    } finally {
      this.isLoading = false;
      if (this.loadingIndicator) this.loadingIndicator.style.display = 'none';
    }
  }
}

if (!customElements.get('infinite-scroll')) {
  customElements.define('infinite-scroll', InfiniteScroll);
}
